import React from 'react';

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]'
};

export const Spinner = ({ size = 'md', className = '' }) => (
  <div
    className={`inline-block rounded-full border-primary dark:border-accent border-t-transparent animate-spin ${SIZES[size] || SIZES.md} ${className}`}
    role="status"
    aria-label="Loading"
  ></div>
);

export const LoadingState = ({ label = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center py-16 gap-3">
    <Spinner size="lg" />
    <p className="text-slate-500 dark:text-slate-400 text-sm font-medium">{label}</p>
  </div>
);

export default Spinner;
